import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

async function GenerarUrlDescargaUnicaBackupService({ anio, trimestre, nombreArchivoDescarga }) {
    try {
        return await instance.Backend.post(
            "/Backup/GenerarUrlDescargaUnica",
            {
                anio,
                trimestre,
                nombreArchivoDescarga,
            },
            customConfig
        );
    } catch (error) {
        console.log(error);
        return null;
    }
}

export { GenerarUrlDescargaUnicaBackupService };
